import React from 'react';
import {Form} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {filter, reduce, toLower} from 'lodash';
import {SUBAPPLICATION_PATHS} from './constants';

class EditCategoryFundingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: true,
      category: '',
      selectedRows: '',
    };
  }

  closeModal = () => {
    this.setState({
      openModal: false,
    });
    this.props.resetActions();
  };

  handleSelectChange = (e) => {
    const {results} = this.props;
    const {value} = e.target;
    const selectedItems = filter(results, (result) => result.checked === true);
    this.setState({
      category: value,
      selectedRows: selectedItems,
    });
  };

  handleCategoryTypeEdit = async () => {
    const {entityId, handleSave} = this.props;
    const {category, selectedRows} = this.state;
    let entities;
    if (entityId) {
      entities = entityId;
    } else if (selectedRows) {
      entities = reduce(
        selectedRows,
        (result, row) => {
          result.push(row.entityId);
          return result;
        },
        []
      );
    }
    await handleSave(entities, SUBAPPLICATION_PATHS.subAppCategory, category);
    this.closeModal();
  };
  render() {
    const {readOnly, results, categoryOptions, categoryLabel} = this.props;
    const {openModal, category} = this.state;
    const selectedItems = filter(results, (result) => result.checked === true);
    const selectedLength = selectedItems.length;
    const numberOfSubApps = selectedLength === 0 ? '1' : selectedLength;

    return (
      <FemaGoModal
        size="tiny"
        title={`Change ${toLower(categoryLabel)}`}
        open={openModal}
        buttonText={'Confirm'}
        confirmAction={this.handleCategoryTypeEdit}
        cancelAction={this.closeModal}
        readOnly={readOnly}
      >
        <Form>
          <p className="pb10">{`These edits will apply to ${numberOfSubApps} selected subapplication(s)`}</p>
          <InlineSelect
            options={categoryOptions}
            name="categoryType"
            id="category"
            label="Select a category of funding for the subappliction(s)"
            value={category}
            size="large"
            handleChange={this.handleSelectChange}
            handleBlur={() => {}}
          />
        </Form>
      </FemaGoModal>
    );
  }
}

export default EditCategoryFundingModal;
